import { StringMap } from 'quill';
import MagicUrl from 'quill-magic-url';
import { Quill } from 'react-quill';

const FONT_SIZES = [
  '8px',
  '9px',
  '10px',
  '11px',
  '12px',
  '14px',
  '18px',
  '24px',
  '30px',
  '36px',
  '48px',
];
const SizeStyle = Quill.import('attributors/style/size');
SizeStyle.whitelist = FONT_SIZES;
Quill.register(SizeStyle, true);
Quill.register('modules/magicUrl', MagicUrl);

export const EDITOR_FORMATS: Array<string> = [
  'bold',
  'strike',
  'italic',
  'underline',
  'size',
  'font',
  'header',
  'color',
  'background',
  'code',
  'link',
  'blockquote',
  'list',
  'bullet',
  'align',
  'indent',
  'image',
];

export const EDITOR_MODULES: StringMap = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ size: FONT_SIZES }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }],
    [{ color: [] }, { background: [] }],
    ['clean'],
  ],
  magicUrl: true,
};

export const isEditorContentEmpty = (editorContent?: string) => {
  // https://github.com/quilljs/quill/issues/1235
  return !editorContent || editorContent === '<p><br></p>';
};
